import React, { useEffect, useState } from "react";
import Button from "components/atoms/Button";
import PageTitle from "components/atoms/PageTitle";
import Select from "components/atoms/SelectInput";
import searchIcon from "../../assets/svg/search-normal.svg";
import SelectFilter from "./SelectFilter";
import Alert from "components/atoms/Alert";
import arrowDown from "../../assets/svg/arrow-down.svg";
import arrowUp from "../../assets/svg/arrow-up.svg";
import FormInput from "components/atoms/FormInput";
import AppDateRange from "./AppDateRange";
import { ToTitleCase } from "components/atoms/CaseManager";
import calenderIcon from "../../assets/svg/calendar.svg";
import cancelIcon from "../../assets/svg/close_x.svg";
import moment from "moment";
import DropdownCard from "components/atoms/Dropdown/DropdownCard";

const PageHeader = (props) => {
  const [dropdown, setDropdown] = useState(false);
  const [showDateRange, setShowDateRange] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchInputErr, setSearchInputErr] = useState("");
  const [startDate_local, setStartDate_local] = useState("");
  const [endDate_local, setEndDate_local] = useState("");

  const searchBoxHandler = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    props.setSearchInput(searchInput);
  };

  useEffect(() => {
    const today = new Date();
    const checkStartDate = props.startDate && new Date(props.startDate);
    const checkEndDate = props.endDate && new Date(props.endDate);
    today.setHours(0, 0, 0, 0);
    checkStartDate && checkStartDate.setHours(0, 0, 0, 0);
    checkEndDate && checkEndDate.setHours(0, 0, 0, 0);

    if (checkStartDate && checkStartDate > today) {
      Alert("error", "Start date cannot exceed today");
      props.setStartDate?.("");
      props.setDateValid?.(false);
      setStartDate_local("");
    } else if (checkEndDate && checkEndDate > today) {
      Alert("error", "End date cannot exceed today");
      props.setEndDate?.("");
      props.setDateValid?.(false);
      setEndDate_local("");
    } else if (
      checkStartDate &&
      checkEndDate &&
      checkStartDate > checkEndDate
    ) {
      Alert("error", "Start date cannot exceed the End date");
      props.setStartDate?.("");
      props.setEndDate?.("");
      props.setDateValid?.(false);
    } else if (!checkStartDate && checkEndDate) {
      Alert("error", "Set the Start date first");
      props.setEndDate?.("");
      setEndDate_local("");
    }

    return props.setDateValid?.(true);
  }, [props.startDate, props.endDate]);

  const dateRange = (
    <div className="flex items-center justify-between gap-5 mobile:w-full tablet:gap-2 animate-slide_up">
      <FormInput
        label="Start Date"
        labelStyle="text-GrayCustom7 text-xs"
        placeholder="Start Date"
        type="date"
        name="start_date"
        style="rounded-lg w-[200px] mobile:w-full tablet:w-1/2"
        inputStyle="border"
        value={startDate_local}
        onChange={(e) => {
          const dateTime = moment(e.target.value).format("YYYY-MM-DD HH:MM:SS");
          props.setStartDate && props.setStartDate(dateTime);
          setStartDate_local(e.target.value);
        }}
        indicatorStyle="hidden"
      />
      <FormInput
        label="End Date"
        labelStyle="text-GrayCustom7 text-xs"
        type="date"
        name="end_date"
        style="rounded-lg w-[200px] mobile:w-full tablet:w-1/2"
        inputStyle="border"
        value={endDate_local}
        onChange={(e) => {
          const dateTime = moment(e.target.value).format("YYYY-MM-DD HH:MM:SS");
          props.setEndDate(dateTime);
          setEndDate_local(e.target.value);
        }}
        indicatorStyle="hidden"
      />
    </div>
  );

  return (
    <div
      className={`${props.wrapperStyle} w-full h-fit flex flex-col ${
        props.loading ? "gap-3" : "gap-5"
      }`}
    >
      {props.loading ? (
        <>
          <div className="flex items-center justify-between gap-5 mb-4 rounded-md">
            <div className="mobile:hidden p-4 rounded-md animate-pulse bg-gray-300 w-[150px] max-w-sm mobile:w-full"></div>
            <div className="flex items-center gap-5 rounded-md animate-pulse w-fit mobile:w-full">
              <div className="p-4 rounded-md bg-gray-300 w-fit mobile:w-full min-w-[150px]"></div>
              <div className="p-4 rounded-md bg-gray-300 w-fit mobile:w-full min-w-[150px]"></div>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-5 rounded-md mobile:grid-cols-1 animate-pulse">
            <div className="p-4 bg-gray-300 rounded-md"></div>
            <div className="p-4 bg-gray-300 rounded-md mobile:hidden"></div>
            <div className="p-4 bg-gray-300 rounded-md mobile:hidden"></div>
            <div className="p-4 bg-gray-300 rounded-md mobile:hidden"></div>
          </div>
        </>
      ) : (
        <>
          <div
            className={`flex ${props.topStyle} ${
              props.actionData?.length > 1
                ? "mobile:flex-col gap-3"
                : "mobile:flex-wrap items-center gap-5"
            } justify-between`}
          >
            <PageTitle
              pageTitle={props.pageTitle}
              pageTitleStyle={props.pageTitleStyle}
              subTitle={props.subText}
              subTitleStyle={props.subTextStyle}
              style="!mt-0 !mb-0"
            />
            {props.actionData && (
              <div className="flex items-center justify-start gap-3">
                {props.actionData.map((item, i) => (
                  <Button
                    key={i}
                    btnType="button"
                    btnText={item.btnText}
                    btnStyle={`${item.btnStyle} !rounded-lg truncate flex gap-4 ju4tify-center items-center px-5 py-2 font-normal text-base leading-7 flex-row-reverse rounded-lg truncate`}
                    btnImg={`${item.btnImg}`}
                    btnImgStyle={`${item.btnImgStyle} w-4 h-4`}
                    onClick={item.handleClick}
                  />
                ))}
              </div>
            )}
          </div>
          <div className="flex items-end justify-between gap-5 mobile:flex-col mobile:justify-start mobile:items-start">
            <div
              className={`${props.bottomStyle} flex tablet:flex-col flex-wrap items-center justify-start tablet:items-start gap-5 mobile:gap-3`}
            >
              {/* <form onSubmit={handleSearchSubmit} className='flex flex-col gap-0 max-w-[300px] mobile:max-w-full w-fit mobile:w-full flex-shrink-0'> */}
              <div className="flex items-center">
                <div className="relative w-1/3">
                  <div
                    className="bg-SecondaryAccent2 text-SecondaryAccent6 w-full !border-SecondaryAccent2 hover:!shadow-none rounded-l-md flex gap-3 justify-center items-center px-5 py-2 font-semibold text-base leading-7 flex-row-reversed truncate cursor-pointer"
                    onClick={() => setDropdown(true)}
                  >
                    {/* {props.searchKey === '' ? 'Search' : ToTitleCase(props.searchKey)} */}
                    Search
                    <img
                      src={dropdown ? arrowUp : arrowDown}
                      alt="dropdown_icon"
                      className="w-3 h-3"
                    />
                  </div>
                  {dropdown && (
                    <DropdownCard
                      handleClickOut={setDropdown}
                      cardLayout="p-1 bg-white rounded-md flex-shrink-0 absolute z-30 w-[180px] animate-slide_right flex flex-col gap-1 shadow-[0_8px_30px_rgb(0,0,0,0.12)]"
                    >
                      {props?.searchOpts.map((item) => (
                        <span
                          className="w-full px-5 py-2 text-sm font-normal truncate rounded-md cursor-pointer hover:bg-BackDrop_d_xs mobile:text-xs overflow-nowrap"
                          onClick={() => {
                            props.setSearchKey(item);
                            setDropdown(false);
                          }}
                        >
                          {ToTitleCase(item)}
                        </span>
                      ))}
                    </DropdownCard>
                  )}
                </div>
                <FormInput
                  type="text"
                  name={"searchbox"}
                  placeholder={
                    props.searchKey === ""
                      ? "Search"
                      : ToTitleCase(props.searchKey)
                  }
                  style={`border !rounded-none !rounded-r-md !border-SecondaryAccent2 w-2/3 relative z-[15]`}
                  inputStyle={`!border-[rgba(0,0,0,0)] border border-transparent text-Black2 py-[2px] w-full bg-white`}
                  inputStyle2="w-[80%]"
                  value={props.searchKey === "" ? "" : props.searchInput}
                  // onChange={searchBoxHandler}
                  onChange={(e) => {
                    props.setSearchInput(e.target.value);
                  }}
                  autoComplete="off"
                  validationErr={searchInputErr}
                  img={searchIcon}
                  imgStyle={`w-4 h-4 !right-3 cursor-pointer`}
                  imgOnClick={() => {}}
                  indicatorStyle="hidden"
                  disabled={props.searchKey === "" ? true : false}
                />
              </div>
              {/* <span className='text-xs font-normal text-SecondaryAccent'>Click the search icon to initiate Search</span> */}
              {/* </form> */}
              <div className="flex items-center justify-start gap-5 tablet:flex-wrap mobile:gap-3">
                {props.filterData.map((item, i) => (
                  <SelectFilter
                    key={i}
                    titleText={item.titleText}
                    filterData={item.filters}
                    selected={item.selected}
                    setSelected={item.setSelected}
                  />
                ))}
              </div>
            </div>

            {props.dateFilter && (
              <div className="relative">
                <img
                  src={cancelIcon}
                  alt="close"
                  className={`${
                    !showDateRange && "hidden"
                  } absolute right-0 -top-3 cursor-pointer w-4 h-4`}
                  onClick={() => {
                    setShowDateRange(false);
                    props.setStartDate("");
                    setStartDate_local("");
                    props.setEndDate("");
                    setEndDate_local("");
                  }}
                />
                {showDateRange ? (
                  dateRange
                ) : (
                  <Button
                    btnType="button"
                    btnText="Date search"
                    btnStyle="animate-slide_up bg-SecondaryAccent2 text-SecondaryAccent6 w-full !border-SecondaryAccent2 hover:!shadow-none truncate flex gap-3 justify-center items-center px-5 py-2 font-semibold text-base leading-7 flex-row-reversed rounded-lg truncate"
                    onClick={() => setShowDateRange((prevState) => !prevState)}
                    btnImg={calenderIcon}
                    btnImgStyle="w-4 h-4"
                  />
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PageHeader;
